/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */
import React from "react";
import { Button, Grid, Header, Image } from "semantic-ui-react";
import { NavLink } from "react-router-dom";
import "./Enrollment.css";

const EnrollmentPV = (props) => {
  if (props.auth) {
    props.logout();
  }
  return (
    <div>
      <style>
        {`
        html {
          background: url(/enrollment/3.png) no-repeat center center fixed;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        }
        body {
          overflow-x: hidden;
          background: none;
        }
      `}
      </style>
      <Grid centered columns={3}>
        <Grid.Column textAlign="center" className="enrollment-grid">
          <Image src="/SALIS.png" size="small" centered />
          <Header className="enrollment-title">SALIS Enrollment System</Header>
          <Header className="enrollment-subtitle">
            ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL
          </Header>
          <Header className="enrollment-subtitle">SY 2025-2026</Header>

          <Button.Group size="huge" style={{ marginTop: "20px" }}>
            <NavLink key="enr-form" to="/enrollment-form">
              <Button>Enrollment Form</Button>
            </NavLink>
            <Button.Or />
            <NavLink key="app-tracker" to="/application-tracker">
              <Button style={{ color: "white", backgroundColor: "#640B18" }}>
                Application Tracker
              </Button>
            </NavLink>
          </Button.Group>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default EnrollmentPV;
